import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { FormSection } from 'components/FormHelper/FormSection';
import { InputField } from 'components/FormHelper/InputField';
import { SectionSubtitle } from 'components/FormHelper/SectionSubtitle';
import { UploadField } from 'components/FormHelper/UploadField/UploadField';
import { HintText } from 'components/HintText/HintText';
import { HINTTEXT_TYPE } from 'components/HintText/HintTextType';
import { MessageFields } from 'components/MyTaskArea/TaskDetailPage/MessageFields';
import { MessageType } from 'components/MyTaskArea/types';
import { getTaskDetailUploadFiles } from 'components/MyTaskArea/utils/taskDetailFormUtils';
import { getDocumentUploadFieldName } from 'components/MyTaskArea/utils/mapTaskDetail';

import './LastMessage.sass';

export const LastMessage = ({
  lastMessage,
  formik,
  isSubmitting,
  submitError,
  submitSuccess,
  entityNameMap,
  comboBoxOptions,
}) => {
  const { message, fields, files } = lastMessage;
  const { values } = formik;

  return (
    <div className="last-message">
      {message && (
        <div className="last-message__clerk-message">
          <SectionSubtitle>Beschreibung (Nachricht vom SB)</SectionSubtitle>
          <p className="last-message__clerk-message__text">{message}</p>
        </div>
      )}
      {fields?.length > 0 && (
        <div>
          <p>Bitte füllen Sie die angeforderten Felder aus.</p>
          <MessageFields
            fields={fields}
            formik={formik}
            entityNameMap={entityNameMap}
            comboBoxOptions={comboBoxOptions}
          />
        </div>
      )}
      {files?.length > 0 && (
        <div>
          <p>Bitte laden Sie die hier aufgelisteten Dokumente erneut hoch.</p>
          <div className="document-list">
            {files.map((fileEntry) => (
              <FormSection key={fileEntry.id} subtitle={`· ${fileEntry.documentType} *`}>
                <UploadField
                  name={getDocumentUploadFieldName(fileEntry.id)}
                  optional={false}
                  files={getTaskDetailUploadFiles(values, fileEntry.id)}
                  formik={formik}
                />
              </FormSection>
            ))}
          </div>
        </div>
      )}
      <FormSection key="changes">
        <InputField
          name="changes"
          fullWidth
          noMaxWidth
          label="Weitere Anmerkungen"
          oldValue=""
          variant="outlined"
          value={values.changes}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.changes)}
          helperText={formik.errors.changes || ''}
        />
      </FormSection>
      <div className="document-list__send">
        {submitError && <HintText type={HINTTEXT_TYPE.ERROR}>{submitError}</HintText>}
        {submitSuccess && <HintText>Ihre Daten wurden erfolgreich übermittelt.</HintText>}
        <ActionButton
          title={isSubmitting ? 'Wird gesendet…' : 'Dokumente senden'}
          onClick={formik.submitForm}
          inverted
          disabled={!formik.isValid || isSubmitting || submitSuccess}
        />
      </div>
    </div>
  );
};

LastMessage.propTypes = {
  lastMessage: MessageType.isRequired,
  formik: PropTypes.object.isRequired,
  entityNameMap: PropTypes.object,
  isSubmitting: PropTypes.bool,
  submitError: PropTypes.string,
  submitSuccess: PropTypes.bool,
  comboBoxOptions: PropTypes.object,
};

LastMessage.defaultProps = {
  isSubmitting: false,
  submitError: null,
  submitSuccess: false,
  entityNameMap: {},
  comboBoxOptions: {},
};
